module.exports = __webpack_public_path__ + "static/img/yy3.262f524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy3.png
// module id = zZ83
// module chunks = 1